import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Buttons from "../../components/ui/button/Buttons";
import FormCreator from "../../components/Forms/FormCreator";
import MolGrid from "../../components/Grid/MolGrid";
import { useGetAllCompetencyListForAllMemberMutation, } from "../../app/services/GMAP/verifiedCompetency";
import { useLazyGetAllDropDownsForMemberDirectoryQuery, } from "../../app/services/common/commonApi";
import { setDropDownField } from "./utils/setFieldParameter";
import { VerifiedCompetencyConfig, VerifiedCompetencySubmissionData } from "./data/VerifiedCompetency.data";
import { encryptAESID } from "../../utils/Encryption";

const initialPagination = {
  pageNo: 1,
  pageSize: 20,
  endPage: 100,
  Name: "",
  GMAPNumber: "",
  StatusId: "",
  VerfiedCompeteciesId: "",
  SubmitedDateFrom: "",
  SubmittedDateTo: "",
  totalCount: 0,
};

const VerifiedCompetencyList = () =>
{
  const verifiedCompetencySubmissionRef = useRef();
  const molRef = useRef();
  const navigate = useNavigate();
  const [ dataSource, setDataSource ] = useState( [] );
  const [ formData, setFormData ] = useState( VerifiedCompetencySubmissionData );
  const [ pagination, setPagination ] = useState( initialPagination );

  const [ fetchCompetencyMembers, { isSuccess: isListSuccess, isLoading: isListLoading, data: competencyMemberData }, ] = useGetAllCompetencyListForAllMemberMutation();
  const [ getAllDropDowns, { isLoading: getDropdownDataIsLoading, data: getDropdownData, isSuccess: getAllDropdownDataIsSuccess }, ] = useLazyGetAllDropDownsForMemberDirectoryQuery();

  useEffect( () =>
  {
    getAllDropDowns();
    fetchCompetencyMembers( pagination );
  }, [] );

  const handleSearch = () =>
  {
    if ( !verifiedCompetencySubmissionRef.current )
    {
      return;
    }
    const taskListFormData = verifiedCompetencySubmissionRef.current.getFormData();
    const updatedRequest = {
      ...initialPagination,
      Name: taskListFormData?.name || null,
      GMAPNumber: taskListFormData?.gmpNumber || null,
      StatusId: taskListFormData?.status?.value || taskListFormData?.status || "",
      VerfiedCompeteciesId: taskListFormData?.verifiedCompetencies?.value || taskListFormData?.verifiedCompetencies || "",
      SubmitedDateFrom: taskListFormData?.submittedDateFrom || null,
      SubmittedDateTo: taskListFormData?.submittedDateTo || null,
    };
    setPagination( updatedRequest );
    fetchCompetencyMembers( updatedRequest );
  };

  const handleClearFilter = () =>
  {
    const clearedForm = {
      ...VerifiedCompetencySubmissionData,
      initialState: {
        name: "",
        gmpNumber: "",
        status: "",
        verifiedCompetencies: "",
        submittedDateFrom: "",
        submittedDateTo: "",
      },
    };

    const resetRequest = {
      ...initialPagination,
      pageNo: 1,
      pageSize: 20,
    };

    setFormData( clearedForm );
    setPagination( resetRequest );
    fetchCompetencyMembers( resetRequest );
    getAllDropDowns();
  };

  const handlePageChange = ( { pageNumber, pageSize } ) =>
  {
    const updatedRequest = { ...pagination, pageNo: pageNumber, pageSize };
    setPagination( updatedRequest );
    fetchCompetencyMembers( updatedRequest );
  };

  useEffect( () =>
  {
    if ( !getDropdownDataIsLoading && getAllDropdownDataIsSuccess && getDropdownData )
    {
      setDropDownField( getDropdownData )
    }
  }, [ getDropdownDataIsLoading, getDropdownData, getAllDropdownDataIsSuccess ] );

  useEffect( () =>
  {
    if ( isListSuccess && competencyMemberData )
    {
      setPagination( ( prev ) => ( { ...prev, totalCount: competencyMemberData.totalCount } ) );
      setDataSource( competencyMemberData.itemList || [] );
    }
  }, [ isListSuccess, competencyMemberData ] );

  const handleUpdateClick = ( data ) =>
  {
    window.open( `/verifiedCompetencySubmission/${ encryptAESID( data?.gmapVerifiedCompetencyId ) }` )
  }

  const actionHandler = {
    EDIT: handleUpdateClick,
  };


  const handleAddRecord = () =>
  {
    navigate( "/addVerifiedCompetency" );
  };

  return (
    <div>
      <div className="row">
        <div className="col-12 col-lg-10">
          <div className="row">
            { !getDropdownDataIsLoading && (
              <FormCreator
                ref={ verifiedCompetencySubmissionRef }
                { ...formData }
              />
            ) }
          </div>
        </div>
        <div className="col-12 col-lg-2">
          <div className="verticle-btn-sec">
            <div>
              <Buttons
                buttonText="Search"
                buttonTypeClassName="btn success-btn w-100 mb-2"
                onClick={ handleSearch }
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-primary w-100"
                onClick={ handleClearFilter }
              />
            </div>
            <Buttons
              buttonText="+ Add Record"
              buttonTypeClassName="btn success-btn w-100"
              onClick={ handleAddRecord }
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <MolGrid
          ref={ molRef }
          configuration={ VerifiedCompetencyConfig }
          dataSource={ dataSource }
          allowPagination={ true }
          isLoading={ isListLoading }
          pagination={ pagination }
          onPageChange={ handlePageChange }
          onActionChange={ actionHandler }
        />
      </div>
    </div>
  );
};

export default VerifiedCompetencyList;
